import type { FunctionComponent } from "react";
import { CampaignDetailsProposalsAdminPartial } from "../../../partials/admin/proposal/campaign-details-proposals.admin.partials";

export const CampaignDetailsProposalsAdminScreen: FunctionComponent = () => {
	return <CampaignDetailsProposalsAdminPartial />;
};
